qw-calendar-guest-inline {
  display: block;
}

qw-calendar-guest-inline qw-input {
  margin-bottom: var(--qw-hotel-gap-md);
}

qw-calendar-guest-inline .qw-calendar-guest-inline__input-fields {
  display: flex;
}
